import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class AdjustPaymentDetailsService {
  constructor(private http: HttpClient) {}

  updateAdjustAoynebtDetailsDetails(adjustPaymentDeatils_data : any, custId: any) : Observable<any> {
      const post_url = baseApiUrl + 'subscriber/adjustPayment/' + custId;
      return this.http.post<any>(post_url, adjustPaymentDeatils_data, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
    }
}